// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"d9878292","270":"7dcbbb80","433":"e7074c2b","668":"2814d5cf","701":"06c6b8c7","761":"9195527a","794":"9bec89e2","918":"fff0d114","966":"776afdef"}[chunkId] + ".chunk.css";
};